<template>
  <v-autocomplete
    :items="list"
    :loading="isLoading"
    :search-input.sync="search"
    :filter="() => true"
    item-text="name"
    item-value="id"
    :label="label"
    v-bind="$attrs"
    v-on="$listeners"
    hide-details="auto"
    :placeholder="placeholder"
    @change="handleChange"
  >
    <template v-if="isMultiple" v-slot:prepend-item>
      <v-list-item>
        <rs-text-field autofocus v-model="search" label="Ara" />
      </v-list-item>
      <v-list-item>
        <rs-action @click="selectVisibleOptions">Tümünü Seç</rs-action>
        <rs-action @click="clearSelectedOptions">Tümünü Kaldır</rs-action>
      </v-list-item>
    </template>
  </v-autocomplete>
</template>

<script>
import { debounce } from "@/core/plugins/debounce";

export default {
  props: {
    label: {
      type: String,
      required: false,
      default: "Yönetim Şirketi Seçin",
    },
    placeholder: {
      type: String,
      required: false,
      default: "Ara",
    },
    extraParams: {
      type: Object,
      required: false,
      default: () => {},
    },
  },
  computed: {
    isMultiple() {
      return (
        this.$attrs.multiple !== undefined && this.$attrs.multiple !== false
      );
    },
    selectedValue() {
      const value = this.$attrs.value;

      if (Array.isArray(value)) {
        return value;
      }

      return value ? [value] : [];
    },
  },
  watch: {
    search: debounce(function () {
      this.loadList();
    }, 250),
  },
  mounted() {
    this.$nextTick(() => this.loadList());
  },
  data() {
    return {
      list: [],
      isLoading: false,
      search: null,
    };
  },
  methods: {
    loadList() {
      if (this.isLoading) {
        return;
      }
      this.isLoading = true;

      const params = Object.assign(
        {
          page: 1,
          per_page: 1000,
          order_by: "name",
          query: this.companySearch,
          company_type_id: 1,
        },
        this.extraParams
      );

      if (this.search) {
        params.query = this.search;
      }
      params.is_active = 1;

      this.$api
        .query("companies", { params })
        .then((response) => {
          this.list = response.data.data;
        })
        .catch((error) => {
          // eslint-disable-next-line
          console.error("Error loading company list", error);
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    emitMultipleSelection(ids) {
      const normalizedIds = ids
        .filter((id) => id !== null && id !== undefined && id !== "")
        .map((id) => Number(id))
        .filter((id) => Number.isInteger(id) && id > 0);
      const uniqueIds = Array.from(new Set(normalizedIds));
      const selectedItems = this.list.filter((item) =>
        uniqueIds.includes(item.id)
      );

      this.$emit("input", uniqueIds);
      this.$emit("change:option", {
        id: uniqueIds,
        items: selectedItems,
      });
    },
    selectVisibleOptions() {
      const visibleIds = this.list.map((item) => item.id);
      this.emitMultipleSelection([...this.selectedValue, ...visibleIds]);
    },
    clearSelectedOptions() {
      this.emitMultipleSelection([]);
    },
    handleChange(selectedId) {
      if (Array.isArray(selectedId)) {
        this.emitMultipleSelection(selectedId);
        return false;
      }

      if (!selectedId) {
        this.$emit("change:option", { id: null, item: null });
        return false;
      }
      let selectedItem;

      for (const index in this.list) {
        if (this.list[index].id === selectedId) {
          selectedItem = Object.assign(this.list[index]);
          break;
        }
      }

      this.$emit("change:option", {
        id: selectedId,
        item: selectedItem,
      });

      this.isLoading = true;
      this.$nextTick(() => {
        this.isLoading = false;
      });

      return false;
    },
    /**
     * Adds a new option to result list.
     * @param  {Object} item Company Object
     * @return {Boolean}      True if added, false if already exists
     */
    pushOption(item) {
      for (const index in this.list) {
        if (this.list[index].id === item.id) {
          return false;
        }
      }
      this.list.push(item);

      return true;
    },
  },
};
</script>
